// extracted by mini-css-extract-plugin
export default {"page404":"Page404_page404__EmgPW","content":"Page404_content__nDTnP","homeButton":"Page404_homeButton__XWd7Q"};